import { z } from "zod";

export const getTicketTypesSchema = z.object({
	state: z
		.any()
		.transform((v) => (Array.isArray(v) ? v : [v]))
		.pipe(z.array(z.enum(["active", "inactive"]))),
});
